import { render } from "./OPINION_MADE_PRIVATE.vue?vue&type=template&id=36aea149"
import script from "./OPINION_MADE_PRIVATE.vue?vue&type=script&lang=js"
export * from "./OPINION_MADE_PRIVATE.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__